import { rem } from 'polished'
import { useCallback, useRef } from 'react'
import * as React from 'react'
import styled from 'styled-components'

import NestableClickable from 'components/Common/NestableClickable'
import CircleCheckboxInput from 'LuxKit/Checkbox/CircleCheckboxInput'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import useToggle from 'hooks/useToggle'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const Root = styled(NestableClickable)`
  display: flex;
  gap: ${rem(12)};
  border-radius: ${(props) => props.theme.borderRadius.S};
  align-items: center;
  padding: ${rem(20)};
  width: 100%;

  &.hide-border {
    padding: 0;
  }

  &.package-container {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    gap: ${rem(12)};

    .package-items {
      flex-direction: column;
    }
  }

  > .click-disabled {
    pointer-events: none;
  }
`

interface Props {
  children: React.ReactNode
  heading: string
  subHeading?: string
  showBorder?: boolean
  image?: App.Image
  imgUrl?: string
  onSelect?: (checked: boolean) => void
}

function PackageBookingItem(props: Props) {
  const { heading, subHeading, children, onSelect } = props
  const { value, toggle } = useToggle(false)
  const checkBoxRef = useRef<HTMLInputElement>(null)

  const onClick = useCallback(() => {
    toggle()
    onSelect?.(!value)
  }, [onSelect, toggle, value])

  return (
    <Root className="package-container" onClick={onClick}>
      <CircleCheckboxInput
        className="click-disabled"
        ref={checkBoxRef}
        checked={value}
      />
      <VerticalSpacer gap={24} className="package-items">
        <div className="packageHeading">
          <Heading lineClamp={1} variant="heading6">
            {heading}
          </Heading>
          {subHeading && <BodyText variant="large">{subHeading}</BodyText>}
        </div>
        {children}
      </VerticalSpacer>
    </Root>
  )
}

export default PackageBookingItem
